<template lang="pug">
  .card.has-text-centered
    .card-content
      p.is-size-6
        b Serie: 
        | &nbsp{{ articulo.serie}}
      p.is-size-7
        b Marca: 
        | &nbsp{{ articulo.marca}} 
      p.is-size-7
        b Modelo:
        | &nbsp{{ articulo.modelo }} 
      p.is-size-7 📌{{ articulo.ubicacion}}
      p.is-size-7 
      b Orden C. 
      | &nbsp{{ articulo.ordenCompra}}
      div.has-text-centered(v-if="articulo.subcategoria")
        .control
          .tags.has-addons
            span.tag.is-black
              i.fas.fa-tag
              | &nbsp {{ articulo.categoria}}
            span.tag.is-warning {{ articulo.subcategoria}}
      div.has-text-center(v-else)
        span.tag.is-black {{ articulo.categoria}}
      p.is-size-7.has-text-danger(v-show="articulo.observaciones")
        | &nbsp {{ articulo.observaciones }}
      a.button.is-primary.is-fullwidth(@click="agregarArticuloSalida(articulo)" v-show="!isSelected" :disabled="isDisabled" v-if="checkAlmacen(articulo.oficina)")
        span 
          | Agregar a Salida 
        span.icon
          i.fas.fa-share-alt 
      a.button.is-default.is-fullwidth(:disabled="isDisabled" v-else)
        span 
          | En Salida / Asignado
        span.icon
          i.fas.fa-ban
      a.button.is-default.is-fullwidth(v-show="isSelected")
        span
          | Seleccionado
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'CardArticulo',
  props: {
    articulo: {
      type: Object,
      default: () => {}
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    origen: {
      type: Object,
      default: () => {}
    },
  },
  data () {
    return {
      isDisabled: false
    }
  },
  watch: {
    articulos_Salida () {
      // console.log('Cambiando articulos_salida')
      // if (this.articulos_Salida.length > 0) {
      //   this.checkSelect()
      // } else {
      //   this.isSelected = false
      // }
    },
    isSelected () {
      if (this.isSelected) {
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
    }
  },
  methods: {
    agregarArticuloSalida () {
      if (!this.disabled) {
        this.$store.commit('agregarArticulos_Salida', this.articulo)
      }
    },
    checkAlmacen (oficina) {
      return this.origen.clave === oficina
    }
  },
  computed: {
    ...mapState(['articulos_Salida', 'userLogin', 'almacenSelect'])
  }
}
</script>

<style scoped>
  .content h5 {
    margin-bottom: 0;
  }
  .card {
    border: 1px solid #54545c;
    -webkit-box-shadow: 2px 2px 2px 0px rgb(0, 0, 0);
    -moz-box-shadow: 2px 2px 2px 0px #54545c;
    box-shadow: 2px 2px 2px 0px #54545c;
  }
  .tags {
    justify-content: center;
  }
  .button.is-fullwidth {
    margin-top: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/components/inventario_Componentes/CardArticulo.vue